import { useState, useMemo } from 'react';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import useProductStore from '@/store/product';

export default function ProductPrice({ data }) {
  const { productAsyncData } = useProductStore();
  const productRecord = data?.productRecord;
  const [showPrice, setShowPrice] = useState(false);

  const priceList = useMemo(() => {
    return productAsyncData?.productRecord?.productPriceList || productRecord?.tieredPrices || [];
  }, [productAsyncData, productRecord]);

  return (
    <Accordion
      type="single"
      collapsible
      className="shadow-[inset_0_-1px_rgba(236,236,236,0.5)]"
      onValueChange={() => setShowPrice(!showPrice)}
    >
      <AccordionItem value="item-1" className="border-b-0">
        <AccordionTrigger className="px-4 py-3 hover:no-underline [&[data-state=open]>div:after]:rotate-180">
          <div className="text-[14px] flex items-center">
            <span>商品单价</span>
            {!showPrice && (
              <>
                <span className="ml-[30px] text-[#0093e6]">
                  {productRecord?.isOversea
                    ? priceList[0]?.countStart
                    : Number(priceList[0]?.spNumber || 0) * Number(productRecord?.theRatio || 0)}
                  +
                </span>
                <span className="ml-[16px] text-[#ea494a]">
                  ￥
                  {priceList[0]?.thePrice || priceList[0]?.thePrice === 0
                    ? priceList[0]?.thePrice
                    : priceList[0]?.price}
                </span>
              </>
            )}
          </div>
        </AccordionTrigger>
        <AccordionContent className="pb-0">
          <div className="border-[#ececec] border border-solid border-b-0">
            {priceList.map((item, index) => (
              <div className="h-[30px] flex items-center border-b-[#ececec] border-b border-solid" key={index}>
                <div className="ml-[18px] w-[98px] h-[30px] leading-[30px] border-r-[#ececec] border-r border-solid text-[#69788a]">
                  {productRecord?.isOversea
                    ? item?.countStart
                    : Number(item?.spNumber) * Number(productRecord?.theRatio)}
                  +
                </div>
                <div className="flex-1 h-[30px] leading-[30px]">
                  <span className="ml-[16px] text-[#e84c4c]">
                    ￥{item?.thePrice || item?.thePrice === 0 ? item?.thePrice : item?.price}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
